import Api from '@api/instance';
import { WdaProfile } from '@models/wda-profile.model';
import { Page } from '@testsigmainc/models';
import axios from 'axios';
import { useInfiniteQuery } from 'react-query';
import { WDA_PROFILES_INFINITE_QUERY_KEY } from '../../constants';
import { mapUserDetails } from '../../utils';
import { getNextPageParam } from '@hooks/use-react-query-caching';

const namespace = '/settings/wda';

const findAll = (query?: string, page?: number) => {
  return Api.get(namespace, {
    query: query ? 'name:*' + query + '*' : undefined,
    page,
  })
    .then((data) => {
      return data;
    })
    .catch(() => {
      throw new Error('Problem while fetching All Provisioning_profile');
    });
};
const remove = (id: number) => {
  return Api.remove(`${namespace}/${id}`)
    .then(() => {})
    .catch(() => {
      throw new Error('Problem while fetching All Provisioning_profile');
    });
};
const create = (formData: FormData) => {
  return axios
    .post(namespace, formData, {
      headers: { 'content-type': 'multipart/form-data' },
    })
    .then((data) => {
      return data;
    })
    .catch((e) => {
      throw e;
    });
};
const update = (id: number, formData: FormData) => {
  return axios
    .put(namespace + '/' + id, formData, {
      headers: { 'content-type': 'multipart/form-data' },
    })
    .then((data) => {
      return data;
    })
    .catch((e) => {
      throw e;
    });
};
const show = (id: any) => {
  return Api.get(namespace + '/' + id)
    .then((res) => {
      return new WdaProfile().deserialize(res);
    })
    .catch((e) => {
      throw e;
    });
};
const WdaService = {
  create,
  findAll,
  update,
  remove,
  show,
};

export const useGetAllWdaProfiles = (searchQuery = '') => {
  const fetchWdaProfiles = async ({ pageParam = 0 }) => {
    const data: Page<WdaProfile> = await findAll(searchQuery, pageParam);
    if (data?.content) {
      await mapUserDetails(data?.content);
    }
    return data;
  };

  return useInfiniteQuery({
    queryKey: `${WDA_PROFILES_INFINITE_QUERY_KEY}-${searchQuery}`,
    queryFn: fetchWdaProfiles,
    getNextPageParam,
    staleTime: 0,
    cacheTime: 0,
  });
};

export default WdaService;
